import { useState } from "react";

export default function Privacy() {
  const sections = [
    ["Information We Collect", "We collect information you provide directly to us, such as your name, email address, and assessment responses. We also collect usage data and device information automatically when you use the app."],
    ["How We Use Your Information", "We use the information we collect to provide, maintain, and improve our services, process transactions, send you technical notices, and respond to your comments and questions."],
    ["Data Storage", "Your data is stored securely using Supabase. We implement appropriate technical and organizational measures to protect your personal information against unauthorized access or disclosure."],
    ["Third-Party Services", "We use third-party services including Supabase (database), Stripe (payments), and RevenueCat (subscription management). These services have their own privacy policies governing the use of your information."],
    ["In-App Purchases", "Payment information is processed securely by Stripe and Apple/Google. We do not store your full payment card details on our servers."],
    ["Data Retention", "We retain your personal information for as long as your account is active or as needed to provide you services. You may request deletion of your data by contacting us."],
    ["Your Rights", "You have the right to access, correct, or delete your personal information. You can delete your account directly from within the app via Sign Out → Delete Account, or contact us at support@miiqfitfinder.com."],
    ["Children Privacy", "Our app is not directed to children under 13. We do not knowingly collect personal information from children under 13."],
    ["Contact Us", "If you have questions about this Privacy Policy, please contact us at support@miiqfitfinder.com."],
  ];
  return (
    <div style={s.page}>
      <div style={s.blob1}/><div style={s.blob2}/>
      <div style={s.container}>
        <div style={s.logoRow}><img src="/logo.png" alt="MiiQ FitFinder" style={s.logoImg}/></div>
        <div style={s.hero}>
          <div style={s.badge}>Legal</div>
          <h1 style={s.h1}>Privacy <span style={{color:"#D4AF37"}}>Policy</span></h1>
          <p style={s.sub}>Last updated: May 2026</p>
        </div>
        <div style={s.card}>
          {sections.map(([title, text], i) => (
            <div key={i} style={{...s.section, borderBottom: i < (sections.length - 1) ? "1px solid rgba(212,175,55,0.1)" : "none"}}>
              <div style={s.sectionNum}>{String(i+1).padStart(2,"0")}</div>
              <div style={{flex:1}}>
                <h2 style={s.h2}>{title}</h2>
                <p style={s.text}>{text}</p>
              </div>
            </div>
          ))}
        </div>
        <div style={s.footer}>
          <a href="/support" style={s.backLink}>Back to Support</a>
          <span style={s.footerText}>2026 Taradome Entertainment Group LLC</span>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:{background:"#2E1A47",minHeight:"100vh",color:"#F9F7F2",fontFamily:"Georgia,serif",overflowX:"hidden",position:"relative"},
  blob1:{position:"fixed",inset:0,background:"radial-gradient(ellipse 80% 50% at 20% 10%,rgba(212,175,55,0.08) 0%,transparent 60%)",pointerEvents:"none",zIndex:0},
  blob2:{position:"fixed",inset:0,background:"radial-gradient(ellipse 60% 80% at 80% 90%,rgba(75,54,99,0.4) 0%,transparent 60%)",pointerEvents:"none",zIndex:0},
  container:{maxWidth:760,margin:"0 auto",padding:"40px 24px 60px",position:"relative",zIndex:1},
  logoRow:{display:"flex",alignItems:"center",marginBottom:48},
  logoImg:{height:64,borderRadius:12},
  logoIcon:{width:36,height:36,background:"linear-gradient(135deg,#D4AF37,#B8860B)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:18,color:"#2E1A47"},
  logoText:{fontSize:20,fontWeight:600,letterSpacing:"0.04em",color:"#F9F7F2"},
  hero:{marginBottom:40},
  badge:{display:"inline-block",background:"rgba(212,175,55,0.1)",border:"1px solid rgba(212,175,55,0.3)",borderRadius:20,padding:"4px 14px",fontSize:11,letterSpacing:"0.1em",textTransform:"uppercase",color:"#D4AF37",marginBottom:16},
  h1:{fontSize:42,fontWeight:700,lineHeight:1.1,color:"#F9F7F2",marginBottom:8},
  sub:{fontSize:14,color:"#9A8C9D"},
  card:{background:"rgba(61,38,90,0.4)",border:"1px solid rgba(212,175,55,0.15)",borderRadius:20,padding:"8px 32px",marginBottom:40},
  section:{display:"flex",gap:24,padding:"28px 0",alignItems:"flex-start"},
  sectionNum:{fontSize:11,fontWeight:700,color:"rgba(212,175,55,0.4)",letterSpacing:"0.1em",minWidth:28,paddingTop:4},
  h2:{fontSize:16,fontWeight:600,color:"#F9F7F2",marginBottom:8,fontFamily:"Georgia,serif"},
  text:{fontSize:14,color:"#9A8C9D",lineHeight:1.8,margin:0},
  footer:{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12},
  backLink:{color:"#D4AF37",textDecoration:"none",fontSize:14},
  footerText:{fontSize:12,color:"rgba(154,140,157,0.5)"},
};
